import styled, { createGlobalStyle } from 'styled-components';

interface IScMainContainer {
	isFooter?: boolean;
	isWhite?: boolean;
}

export const GlobalLayoutStyle = createGlobalStyle`
	html {
		scrollbar-gutter: stable;
	}
`;

export const ScMainContainer = styled.div<IScMainContainer>`
	background: ${({ theme, isWhite }) => (isWhite ? theme.colors.white : theme.colors.strongWhite)};
	min-height: 100vh;
	padding-bottom: ${({ isFooter }) => (isFooter ? '20px' : 0)};
	@media (min-width: 768px) {
		padding-bottom: ${({ isFooter }) => (isFooter ? '50px' : 0)};
	}
`;
